import React from "react";
import "./PhoneMockups.css";

// Tab icons reused across all three phone bottom navs
const TabIcons = {
  Logs: (
    <svg viewBox="0 0 24 24">
      <rect x="3" y="3" width="18" height="18" rx="2" />
      <line x1="3" y1="9" x2="21" y2="9" />
    </svg>
  ),
  Maps: (
    <svg viewBox="0 0 24 24">
      <polygon points="3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21" />
      <line x1="9" y1="3" x2="9" y2="18" />
      <line x1="15" y1="6" x2="15" y2="21" />
    </svg>
  ),
  Assist: (
    <svg viewBox="0 0 24 24">
      <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" />
      <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
    </svg>
  ),
  Weather: (
    <svg viewBox="0 0 24 24">
      <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z" />
    </svg>
  ),
  Settings: (
    <svg viewBox="0 0 24 24">
      <circle cx="12" cy="8" r="4" />
      <path d="M4 20v-1a8 8 0 0 1 16 0v1" />
    </svg>
  ),
};

function BottomNav({ active }) {
  return (
    <div className="ps-bottom-nav">
      {Object.entries(TabIcons).map(([label, icon]) => (
        <div
          key={label}
          className={`ps-tab ${active === label ? "active" : ""}`}
        >
          {icon}
          <span>{label}</span>
        </div>
      ))}
    </div>
  );
}

// Left phone — Maps screen
function PhoneLeft() {
  return (
    <div className="phone-frame back-l">
      <div className="phone-notch" />
      <div className="phone-screen">
        <div className="ps-nav">
          <span className="ps-title">Maps</span>
        </div>
        <div className="map-placeholder">
          <svg
            width="40"
            height="40"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#bbb"
            strokeWidth="1.5"
          >
            <path d="M12 22s-8-4.5-8-11.8A8 8 0 0 1 12 2a8 8 0 0 1 8 8.2c0 7.3-8 11.8-8 11.8z" />
            <circle cx="12" cy="10" r="3" />
          </svg>
        </div>
        <BottomNav active="Maps" />
      </div>
    </div>
  );
}

// Center phone — AI Chat screen
function PhoneFront() {
  return (
    <div className="phone-frame front">
      <div className="phone-notch" />
      <div className="ps-screen-chat">
        <div className="ps-chat-header">
          <div className="ps-avatar">RD</div>
          <div>
            <div className="ps-chat-name">RoadDogg AI</div>
            <div className="ps-chat-sub">Your AI Co-Pilot on Every Road</div>
          </div>
        </div>

        <div className="ps-chat-messages">
          <div className="ps-bubble">
            Good morning, Gabriel. What route are we driving today?
          </div>
        </div>

        <div className="ps-input-row">
          <div className="ps-input-placeholder">
            Ask RoadDogg AI anything...
          </div>
          {/* Mic icon */}
          <div
            style={{
              width: "24px",
              height: "24px",
              borderRadius: "50%",
              background: "#eee",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <svg
              width="11"
              height="11"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#888"
              strokeWidth="2"
            >
              <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" />
              <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
            </svg>
          </div>
          <div className="ps-send">
            <svg viewBox="0 0 24 24">
              <line x1="22" y1="2" x2="11" y2="13" />
              <polygon points="22 2 15 22 11 13 2 9 22 2" />
            </svg>
          </div>
        </div>

        <BottomNav active="Assist" />
      </div>
    </div>
  );
}

// Right phone — Logs/File Cabinet screen
function PhoneRight() {
  return (
    <div className="phone-frame back-r">
      <div className="phone-notch" />
      <div className="phone-screen">
        <div className="ps-nav">
          <span className="ps-title">Logs</span>
        </div>

        <div className="ps-header-card">
          <div className="ps-stats">
            <div className="ps-stat">
              <div className="n">8</div>
              <div className="l">Folders</div>
            </div>
            <div className="ps-stat">
              <div className="n">4</div>
              <div className="l">Items</div>
            </div>
            <div className="ps-stat">
              <div className="n">3</div>
              <div className="l">Recent</div>
            </div>
          </div>
        </div>

        <div className="ps-card">
          <div className="ps-icon" style={{ background: "#FFF3E8" }}>
            ⛽
          </div>
          <div className="ps-card-text">
            <div className="title">Expense Log</div>
            <div className="sub">Gas, costs, and spending notes</div>
          </div>
        </div>
        <div className="ps-card">
          <div className="ps-icon" style={{ background: "#EBF3FF" }}>
            🚛
          </div>
          <div className="ps-card-text">
            <div className="title">Activity Log</div>
            <div className="sub">Destinations, routes, and notes</div>
          </div>
        </div>
        <div className="ps-card">
          <div className="ps-icon" style={{ background: "#FFF0F0" }}>
            🔧
          </div>
          <div className="ps-card-text">
            <div className="title">Maintenance Log</div>
            <div className="sub">Oil changes, tires, service</div>
          </div>
        </div>

        <BottomNav active="Logs" />
      </div>
    </div>
  );
}

export default function PhoneMockups() {
  return (
    <div className="hero-phones anim-phones">
      <PhoneLeft />
      <PhoneFront />
      <PhoneRight />
    </div>
  );
}
